import React, { useState, ChangeEvent, FormEvent } from 'react';
import { IBritaxProductRegistrationView } from '../britax-product-registration';
import { Button, getTelemetryAttributes, ITelemetryContent, IPayLoad } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as DataActionExtension from '../../../actions/DataActionExtension.g';
import { initialErrorState, InputID, IProductType, productRegistrationState } from '../model/model';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { getUrlSync } from '@msdyn365-commerce/core';
import { ErrorComponent } from '../utils/britax-error';
import { convertDate } from '../utils/britax-date-convert';
import { handleValidation, validateField } from '../utils/britax-validations';

export interface IBritaxProductRegistrationViewProps {
    props: IBritaxProductRegistrationView;
    moduleClassName: string;
    telemetryContent: ITelemetryContent;
    payLoad?: IPayLoad;
}

const ProductRegistrationForm: React.FC<IBritaxProductRegistrationViewProps> = ({ props, moduleClassName, telemetryContent, payLoad }) => {
    const [formData, setFormData] = useState<productRegistrationState>({
        [InputID.firstName]: '',
        [InputID.lastName]: '',
        [InputID.email]: '',
        [InputID.contactNumber]: '',
        [InputID.productType]: '',
        [InputID.productName]: '',
        [InputID.storeName]: '',
        [InputID.itemNumber]: '',
        [InputID.serialNumber]: '',
        [InputID.reorderCode]: '',
        [InputID.dateOfPurchase]: undefined,
        [InputID.dateOfManufacture]: undefined
    });

    const [errors, setErrors] = useState({
        [InputID.firstName]: '',
        [InputID.lastName]: '',
        [InputID.email]: '',
        [InputID.contactNumber]: '',
        [InputID.productType]: '',
        [InputID.productName]: '',
        [InputID.storeName]: '',
        [InputID.dateOfPurchase]: '',
        [InputID.dateOfManufacture]: '',
        [InputID.itemNumber]: '',
        [InputID.serialNumber]: '',
        [InputID.reorderCode]: ''
    });
    //@ts-ignore
    const [hasErrors, setHasErrors] = useState(true);
    const [errorMessageTitle, setErrorMessageTitle] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState('');
    //         firstNameErrorMessage,
    //         lastNameErrorMessage,
    //         emailErrorMessage,
    //         contactNumberErrorMessage,
    //         contactNumberMaxLengthErrorMessage,
    //         productTypeErrorMessage,
    //         productNameErrorMessage,
    //         storeNameErrorMessage,
    //         dateOfPurchaseErrorMessage,
    //         dateOfManufactureErrorMessage,
    //         itemNumberErrorMessage,
    //         serialNumberErrorMessage,
    //         reorderCodeErrorMessage
    //     } = props?.resources;

    //     switch (name) {
    //         case InputID.firstName:
    //             if (!value) {
    //                 return firstNameErrorMessage;
    //             }
    //             break;
    //         case InputID.lastName:
    //             if (!value) {
    //                 return lastNameErrorMessage;
    //             }
    //             break;
    //         case InputID.email:
    //             if (!value) {
    //                 return emailErrorMessage;
    //             }
    //             break;
    //         case InputID.contactNumber:
    //             if (!value) {
    //                 return contactNumberErrorMessage;
    //             } else if (!/^[0-9]{10}$/.test(value)) {
    //                 return contactNumberMaxLengthErrorMessage;
    //             }
    //             break;
    //         case InputID.productType:
    //             if (!value) {
    //                 return productTypeErrorMessage;
    //             }
    //             break;
    //         case InputID.productName:
    //             if (!value) {
    //                 return productNameErrorMessage;
    //             }
    //             break;
    //         case InputID.storeName:
    //             if (!value) {
    //                 return storeNameErrorMessage;
    //             }
    //             break;
    //         case InputID.dateOfManufacture:
    //             if (!value) {
    //                 return dateOfManufactureErrorMessage;
    //             }
    //             break;

    //         case InputID.dateOfPurchase:
    //             if (!value) {
    //                 return dateOfPurchaseErrorMessage;
    //             }
    //             break;
    //         case InputID.itemNumber:
    //             if (!value && formData[InputID.productType] === 'stroller') {
    //                 return itemNumberErrorMessage;
    //             }
    //             break;
    //         case InputID.serialNumber:
    //             if (!value && formData[InputID.productType] === 'carSeat') {
    //                 return serialNumberErrorMessage;
    //             }
    //             break;
    //         case InputID.reorderCode:
    //             if (!value && formData[InputID.productType] === 'carSeat') {
    //                 return reorderCodeErrorMessage;
    //             }
    //             break;
    //         default:
    //             break;
    //     }
    //     return '';
    // };
    const resetErrorMessages = () => {
        setErrorMessageTitle('');
        setErrorMessage('');
    };
    //@ts-ignore
    const resetErrors = () => {
        setErrors(initialErrorState);
    };
    //@ts-ignore
    const handleClick = (e: React.MouseEvent<HTMLElement>): void => {
        const { name, value } = e.target as HTMLButtonElement;

        // const newErrors = { ...errors };
        resetErrorMessages();
        const newErrors = validateField(name, value, props, formData);

        setErrors(newErrors);

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleClickEvent = (e: React.MouseEvent<HTMLButtonElement>): void => {
        const { name, value } = e.currentTarget;

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: handleValidation(name, value, props, formData)
        }));
        resetErrorMessages();
    };
    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;
        //resetErrors();
        // resetErrorMessages();
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: handleValidation(name, value, props, formData)
        }));
    };
    const handleBlur = (event: React.FocusEvent<HTMLInputElement>): void => {
        const { name, value } = event.target;
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: handleValidation(name, value, props, formData)
        }));
        resetErrorMessages();
    };
    const handleFocus = (event: React.FocusEvent<HTMLInputElement>): void => {
        const { name, value } = event.target;

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: handleValidation(name, value, props, formData)
        }));
        resetErrorMessages();
    };

    const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>): void => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        //resetErrors();
        //resetErrorMessages();
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: handleValidation(name, value, props, formData)
        }));
    };

    const handleSubmit = (e: FormEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        const newErrors = { ...errors };
        let formHasErrors = false;

        Object.keys(formData).forEach(key => {
            // eslint-disable-next-line security/detect-object-injection
            const error = handleValidation(key, formData[key], props, formData);
            if (error) {
                formHasErrors = true;
            }
            // eslint-disable-next-line security/detect-object-injection
            newErrors[key] = error;
        });

        setErrors(newErrors);
        setHasErrors(formHasErrors);
        if (!formHasErrors) {
            const sendDataPromise = new Promise((resolve, reject) => {
                const {
                    firstName,
                    lastName,
                    email,
                    contactNumber,
                    productType,
                    productName,
                    storeName,
                    itemNumber,
                    dateOfPurchase,
                    dateOfManufacture,
                    serialNumber,
                    reorderCode
                } = formData;
                const cutsAccount = (props.data.accountInformation && props.data.accountInformation.result?.AccountNumber) ?? '';
                DataActionExtension.sendRegistratonDataAsync(
                    { callerContext: props.context.actionContext },
                    firstName,
                    lastName,
                    email,
                    contactNumber,
                    productType,
                    productName,
                    storeName,
                    dateOfPurchase?.toString() ?? '',
                    dateOfManufacture?.toString() ?? '',
                    itemNumber,
                    '',
                    serialNumber,
                    reorderCode,
                    cutsAccount
                )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
            //@ts-ignore
            const successURL =
                (confirmationLink && confirmationLink.linkUrl && confirmationLink.linkUrl.destinationUrl) ||
                getUrlSync('home', props.context.actionContext);
            resetErrorMessages();
            sendDataPromise
                .then(response => {
                    resetErrors();
                    setTimeout(() => {
                        window.location.assign(successURL ?? '');
                    }, 100);
                })
                .catch(error => {
                    setErrorMessageTitle(props.resources.errorMessageTitle);
                    setErrorMessage(props.resources.errorMessage);
                });
        }
    };

    const productType: IProductType[] = [
        { id: 1, name: 'Stroller', value: 'stroller', role: 'Admin' },
        { id: 2, name: 'Car Seat', value: 'carSeat', role: 'User' }
    ];

    const {
        firstNameLabel,
        lastNameLabel,
        emailLabel,
        contactNumberLabel,
        productTypeLabel,
        productNameLabel,
        storeNameLabel,
        dateOfPurchaseLabel,
        dateOfManufactureLabel,
        manufactureDateLabel,
        itemNumberLabel,
        serialNumberLabel,
        reorderCodeLabel,
        submitButtonLabel,
        productTypeHelpText,
        contactNumberNZBasedSiteLabel
    } = props?.resources;

    const { productInformationImage_1, productInformationImage_2, confirmationLink, isNZBasedConfig } = props?.config;
    // eslint-disable-next-line prefer-const
    const contactNumberText = !isNZBasedConfig ? contactNumberLabel : contactNumberNZBasedSiteLabel;
    const { personalInformationLabel, productInformationLabel, productHelpText } = props?.config;
    const attributes = getTelemetryAttributes(telemetryContent, payLoad!);
    const successPageURL =
        (confirmationLink && confirmationLink.linkUrl && confirmationLink.linkUrl.destinationUrl) ||
        getUrlSync('home', props.context.actionContext);
    const __renderStroller = (): JSX.Element => {
        return (
            <>
                <div className={`${moduleClassName}__product__info__configs__columns`}>
                    <div className={`${moduleClassName}__product__info__configs__date_of__manufacture`}>
                        <label
                            htmlFor={dateOfManufactureLabel}
                            className={classnames({ 'error-label': errors[InputID.dateOfManufacture] })}
                        >
                            {dateOfManufactureLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control custom-date-input', {
                                error: errors[InputID.dateOfManufacture]
                            })}
                            type='date'
                            aria-label={dateOfManufactureLabel}
                            name={InputID.dateOfManufacture}
                            onChange={handleChange}
                            value={convertDate(formData[InputID.dateOfManufacture])}
                        />
                        {errors[InputID.dateOfManufacture] && <span className='error-span'>{errors[InputID.dateOfManufacture]}</span>}
                        <span className={`${moduleClassName}__product__info__help_text`}>
                            {<Msdyn365.RichTextComponent text={`${productHelpText}`} />}{' '}
                        </span>
                    </div>
                    <div className={`${moduleClassName}__product__info__configs__item__number`}>
                        <label htmlFor={itemNumberLabel} className={classnames({ 'error-label': errors[InputID.itemNumber] })}>
                            {itemNumberLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { error: errors[InputID.itemNumber] })}
                            type='text'
                            aria-label={itemNumberLabel}
                            name={InputID.itemNumber}
                            onChange={handleChange}
                            value={formData[InputID.itemNumber]}
                        />
                        {errors[InputID.itemNumber] && <span className='error-span'>{errors[InputID.itemNumber]}</span>}
                        <span className={`${moduleClassName}__product__info__help_text`}>
                            {<Msdyn365.RichTextComponent text={`${productHelpText}`} />}{' '}
                        </span>
                    </div>
                </div>
                <div className={`${moduleClassName}__product__info__configs__columns`}>
                    {/* <div className={`${moduleClassName}__product__info__configs__images`}></div> */}
                    <div className={`${moduleClassName}__product__info__configs__images`}>
                        <img src={productInformationImage_1?.src} alt={productInformationImage_1?.altText}></img>
                    </div>
                </div>
            </>
        );
    };
    const __renderCarSeat = (): JSX.Element => {
        return (
            <>
                <div className={`${moduleClassName}__product__info__configs__columns`}>
                    <div className={`${moduleClassName}__product__info__configs__serial__number`}>
                        <label htmlFor={itemNumberLabel} className={classnames({ 'error-label': errors[InputID.serialNumber] })}>
                            {serialNumberLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { error: errors[InputID.serialNumber] })}
                            type='text'
                            aria-label={serialNumberLabel}
                            name={InputID.serialNumber}
                            onChange={handleChange}
                            value={formData[InputID.serialNumber]}
                        />
                        {errors[InputID.serialNumber] && <span className='error-span'>{errors[InputID.serialNumber]}</span>}
                        <span className={`${moduleClassName}__product__info__help_text`}>
                            {<Msdyn365.RichTextComponent text={`${productHelpText}`} />}{' '}
                        </span>
                    </div>
                    <div className={`${moduleClassName}__product__info__configs__date_of__manufacture`}>
                        <label htmlFor={manufactureDateLabel} className={classnames({ 'error-label': errors[InputID.dateOfManufacture] })}>
                            {manufactureDateLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control custom-date-input', {
                                error: errors[InputID.dateOfManufacture]
                            })}
                            type='date'
                            aria-label={dateOfManufactureLabel}
                            name={InputID.dateOfManufacture}
                            onChange={handleChange}
                            value={convertDate(formData[InputID.dateOfManufacture])}
                        />
                        {errors[InputID.dateOfManufacture] && <span className='error-span'>{errors[InputID.dateOfManufacture]}</span>}
                        <span className={`${moduleClassName}__product__info__help_text`}>
                            {<Msdyn365.RichTextComponent text={`${productHelpText}`} />}{' '}
                        </span>
                    </div>
                    <div className={`${moduleClassName}__product__info__configs__reorder__code`}>
                        <label htmlFor={itemNumberLabel} className={classnames({ 'error-label': errors[InputID.reorderCode] })}>
                            {reorderCodeLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { error: errors[InputID.reorderCode] })}
                            type='text'
                            aria-label={reorderCodeLabel}
                            name={InputID.reorderCode}
                            onChange={handleChange}
                            value={formData[InputID.reorderCode]}
                        />
                        {errors[InputID.reorderCode] && <span className='error-span'>{errors[InputID.reorderCode]}</span>}
                        <span className={`${moduleClassName}__product__info__help_text`}>
                            {<Msdyn365.RichTextComponent text={`${productHelpText}`} />}{' '}
                        </span>
                    </div>
                </div>
                <div className={`${moduleClassName}__product__info__configs__columns`}>
                    {/* <div className={`${moduleClassName}__product__info__configs__images`}></div>
                    <div className={`${moduleClassName}__product__info__configs__images`}></div> */}
                    <div className={`${moduleClassName}__product__info__configs__images`}>
                        <img src={productInformationImage_2?.src} alt={productInformationImage_2?.altText}></img>
                    </div>
                </div>
            </>
        );
    };
    return (
        <>
            <form>
                <div className={`${moduleClassName}__personal__info__title__container`}>
                    <h1>{personalInformationLabel}</h1>
                </div>

                <div className={`${moduleClassName}__personal__info`}>
                    <div className={`${moduleClassName}__personal__info__names`}>
                        <div className={`${moduleClassName}__personal__info__name`}>
                            <label htmlFor={InputID.firstName} className={classnames({ 'error-label': errors[InputID.firstName] })}>
                                {firstNameLabel}:
                            </label>
                            <input
                                className={classnames('ms-product-registration__form-control', { error: errors[InputID.firstName] })}
                                type='text'
                                aria-label={firstNameLabel}
                                name={InputID.firstName}
                                onChange={handleChange}
                                value={formData[InputID.firstName]}
                            />
                            {errors[InputID.firstName] && <span className='error-span'>{errors[InputID.firstName]}</span>}
                        </div>
                        <div className={`${moduleClassName}__personal__info__name`}>
                            <label htmlFor={InputID.lastName} className={classnames({ 'error-label': errors[InputID.lastName] })}>
                                {lastNameLabel}:
                            </label>
                            <input
                                className={classnames('ms-product-registration__form-control', { error: errors[InputID.lastName] })}
                                type='text'
                                aria-label={lastNameLabel}
                                name={InputID.lastName}
                                onChange={handleChange}
                                value={formData[InputID.lastName]}
                            />
                            {errors[InputID.lastName] && <span className='error-span'>{errors[InputID.lastName]}</span>}
                        </div>
                    </div>
                    <div className={`${moduleClassName}__personal__info__email`}>
                        <label htmlFor={InputID.email} className={classnames({ 'error-label': errors[InputID.email] })}>
                            {emailLabel}:
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { error: errors[InputID.email] })}
                            type='email'
                            aria-label={emailLabel}
                            name={InputID.email}
                            onChange={handleChange}
                            value={formData[InputID.email]}
                            pattern='^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$'
                        />
                        {errors[InputID.email] && <span className='error-span'>{errors[InputID.email]}</span>}
                    </div>
                    <div className={`${moduleClassName}__personal__info__contact`}>
                        <label htmlFor={InputID.contactNumber} className={classnames({ 'error-label': errors[InputID.contactNumber] })}>
                            {contactNumberText}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { error: errors[InputID.contactNumber] })}
                            type='tel'
                            aria-label={contactNumberText}
                            name={InputID.contactNumber}
                            onChange={handleChange}
                            value={formData[InputID.contactNumber]}
                            pattern={isNZBasedConfig ? undefined : '^(?:\\d){10}$'}
                        />
                        {errors[InputID.contactNumber] && <span className='error-span'>{errors[InputID.contactNumber]}</span>}
                    </div>
                </div>
                <div className={`${moduleClassName}__product__info__title__container product`}>
                    <h1>{productInformationLabel}</h1>
                </div>

                <div className={`${moduleClassName}__product__info`}>
                    <div className={`${moduleClassName}__product__info__name`}>
                        <label htmlFor={InputID.productType} className={classnames({ 'error-label': errors[InputID.productType] })}>
                            {productTypeLabel}
                        </label>
                        <select
                            className={classnames('ms-product-registration__form-control ms-product-registration__product__info__select', {
                                error: errors[InputID.productType]
                            })}
                            aria-label={productTypeLabel}
                            name={InputID.productType}
                            onChange={handleSelectChange}
                            value={formData[InputID.productType]}
                        >
                            <option value='' disabled></option>
                            {productType.map(option => (
                                <option
                                    key={option.id}
                                    value={option.value}
                                    className={classnames('ms-product-registration__product__info__select__options')}
                                >
                                    {option.name}
                                </option>
                            ))}
                        </select>
                        <span className={`${moduleClassName}__product__info__help_text`}>
                            {' '}
                            {<Msdyn365.RichTextComponent text={`${productTypeHelpText}`} />}
                        </span>
                        {errors[InputID.productType] && <span className='error-span'>{errors[InputID.productType]}</span>}
                    </div>
                    <div className={`${moduleClassName}__product__info__name`}>
                        <label htmlFor={InputID.productName} className={classnames({ 'error-label': errors[InputID.productName] })}>
                            {productNameLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { inputError: errors[InputID.productName] })}
                            type='text'
                            aria-label={productNameLabel}
                            name={InputID.productName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            onClick={() => handleClickEvent}
                            value={formData[InputID.productName]}
                        />
                        {errors[InputID.productName] && <span className='error-span'>{errors[InputID.productName]}</span>}
                    </div>
                    <div className={`${moduleClassName}__product__info__name`}>
                        <label htmlFor={InputID.storeName} className={classnames({ 'error-label': errors[InputID.storeName] })}>
                            {storeNameLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control', { error: errors[InputID.storeName] })}
                            type='text'
                            aria-label={storeNameLabel}
                            name={InputID.storeName}
                            onChange={handleChange}
                            value={formData[InputID.storeName]}
                        />
                        {errors[InputID.storeName] && <div className='error-span'>{errors[InputID.storeName]}</div>}
                    </div>
                    <div className={`${moduleClassName}__product__info__date`}>
                        <label htmlFor={dateOfPurchaseLabel} className={classnames({ 'error-label': errors[InputID.dateOfPurchase] })}>
                            {dateOfPurchaseLabel}
                        </label>
                        <input
                            className={classnames('ms-product-registration__form-control custom-date-input', {
                                error: errors[InputID.dateOfPurchase]
                            })}
                            type='date'
                            aria-label={dateOfPurchaseLabel}
                            name={InputID.dateOfPurchase}
                            onChange={handleChange}
                            value={convertDate(formData[InputID.dateOfPurchase])}
                        />
                        {errors[InputID.dateOfPurchase] && <span className='error-span'>{errors[InputID.dateOfPurchase]}</span>}
                    </div>
                    <div className={`${moduleClassName}__product__info__configs`}>
                        {formData[InputID.productType] === 'carSeat' ? (
                            <>{__renderCarSeat()}</>
                        ) : formData[InputID.productType] === 'stroller' ? (
                            <>{__renderStroller()}</>
                        ) : (
                            <></>
                        )}
                    </div>
                    <>
                        {errorMessageTitle !== '' && (
                            <ErrorComponent className={moduleClassName} title={errorMessageTitle} message={errorMessage} />
                        )}
                    </>
                    <div className={`${moduleClassName}__product__info__button__container`}>
                        <Button
                            className={classnames(`${moduleClassName}__product__info__button__container__button`)}
                            aria-label={submitButtonLabel}
                            onClick={handleSubmit}
                            title={submitButtonLabel}
                            href={successPageURL}
                            {...attributes}
                        >
                            {submitButtonLabel}
                        </Button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default ProductRegistrationForm;
